import script from "./ipDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./ipDetail.vue?vue&type=script&setup=true&lang=js"

import "./ipDetail.vue?vue&type=style&index=0&id=ea957c7e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ea957c7e"]])

export default __exports__